import { API } from 'aws-amplify';
import { FILE_VALIDATION_SERVICE } from 'utils/const';

export const getValidationMsgsByGroup = async ({
  path,
  messageGroupId,
  uploadedAt,
  uploadedUserId,
}) => {
  try {
    const response = await API.get(FILE_VALIDATION_SERVICE.API, path, {
      queryStringParameters: {
        messageGroupId,
        uploadedAt,
        uploadedUserId,
      },
    });
    return { data: response };
  } catch (err) {
    return { error: err.message };
  }
};
